import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../utils/reduxHelper.js";

export const profileReduxAPI = createApi({
  reducerPath: "profileReduxAPI",
  baseQuery: baseQueryWithArgs,
  tagTypes: ["CTKkeywords"],

  endpoints: (builder) => ({
    unlinkSocialMediaHandle: builder.mutation({
      query: (body) => ({
        url: `/c/unlinkSocialMediaHandle`,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: ["InstagramLogin", "YoutubeLogin"],
    }),
    getCreatorKeywords: builder.query({
      query: () => ({
        url: getQueryStringWithCreator(`c/getCreatorKeywords`),
      }),
      providesTags: ["CTKkeywords"],
    }),
    updateCreatorKeywords: builder.mutation({
      query: ({ keyword_list }) => ({
        url: `c/updateCreatorKeywords`,
        method: "POST",
        body: postQueryBodyWithCreator({
          keyword_list,
        }),
      }),
      invalidatesTags: ["CTKkeywords"],
    }),
    addCreatorKeywords: builder.mutation({
      query: ({ keyword }) => ({
        url: `c/addCreatorKeywords`,
        method: "POST",
        body: postQueryBodyWithCreator({
          keyword,
        }),
      }),
      invalidatesTags: ["CTKkeywords"],
    }),
    getCreatorCategoryTags: builder.query({
      query: () => getQueryStringWithCreator(`c/getCreatorCategoryTags`),
    }),
    completeCreatorProfile: builder.mutation({
      query: (body) => ({
        url: `c/completeCreatorProfile`,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
    handleTelegramLogin: builder.mutation({
      query: (body) => ({
        url: `c/handleTelegramLogin`,
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetCreatorKeywordsQuery,
  useGetCreatorCategoryTagsQuery,
  useUnlinkSocialMediaHandleMutation,
  useUpdateCreatorKeywordsMutation,
  useAddCreatorKeywordsMutation,
  useCompleteCreatorProfileMutation,
  useHandleTelegramLoginMutation,
} = profileReduxAPI;
